module.exports = __webpack_public_path__ + "img/patientbg.1154fcd3.png";